import { useReducer } from 'react';
import { useSwipeable } from 'react-swipeable';

import { ACTION_TYPE } from '@spa/shared/constants/carouselTypes';
import { order } from '@spa/shared/utils/order';

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPE.PREV:
      return { ...state, active: order(state.length, state.active, -1), translate: 100 };
    case ACTION_TYPE.NEXT:
      return { ...state, active: order(state.length, state.active), translate: -100 };
    case ACTION_TYPE.GOTO:
      return { ...state, active: action.desired };
    case ACTION_TYPE.RESET:
      return { ...state, translate: 0 };
    default:
      return state;
  }
};

export const useSwipe = ({ slides, active = 0, translate = 0 }) => {
  const [state, dispatch] = useReducer(reducer, { active, translate, length: slides.length });
  const setActive = desired => dispatch({ type: ACTION_TYPE.GOTO, desired });
  const goLeft = e => {
    e.preventDefault();
    e.stopPropagation();

    dispatch({ type: ACTION_TYPE.PREV });
  };
  const goRight = e => {
    e.preventDefault();
    e.stopPropagation();

    dispatch({ type: ACTION_TYPE.NEXT });
  };

  const handlers = useSwipeable({
    onSwipedLeft() {
      dispatch({ type: ACTION_TYPE.NEXT });
    },
    onSwipedRight() {
      dispatch({ type: ACTION_TYPE.PREV });
    },
    preventScrollOnSwipe: true,
    trackMouse: true,
    trackTouch: true
  });

  const resetTranslate = () => dispatch({ type: ACTION_TYPE.RESET });

  return [state, setActive, goLeft, goRight, handlers, resetTranslate];
};
